import { toDateString } from '@comparit/shared';
import type { SachVertragsdaten } from '../../interfaces';
import type { VertragsdatenStepForms } from './vertragsdaten-form.service';

/**
 * `zahlungsart` stays out: the funnel never asks for it and the Sparte falls back to Lastschrift.
 */
export const mapVertragsdatenToDto = (value: VertragsdatenStepForms): SachVertragsdaten => ({
  ...value.step2,
  vertragsbeginn: toDateString(value.step2.vertragsbeginn) || null,
});
